import moment from 'moment'
export const TOKEN = 'D9B7F7BC-85FB-40FD-A464-A4467BB4D8F7'
export const QINIU_DOMAIN = process.env.VUE_APP_QINIU_DOMAIN
export const OSS_BUCKET = process.env.VUE_APP_OSS_BUCKET
export const OSS_REGION = process.env.VUE_APP_OSS_REGION

//  #5771->ebay
// #6100->PRA
export const COLOR_CUSTOMIZED_COMPANY_IDS = [3738, 4423, 4474, 4335, 4753, 4798, 5021, 5394, 5771, 6083, 6085, 6100, 6117]

export const CUSTOM_MOBILE_LANDING_CUSTOMIZED_COLOR = {
  // #company_id: color
  3738: '#006341',
  4335: '#EE3124',
  4423: '#00649D',
  4474: '#0A2756',
  4753: '#F36633',
  4798: '#E10000',
  5021: '#843a96',
  5394: 'rgb(20, 48, 110)',
  5771: '#0064D2',
  6083: '#ffc836',
  6085: '#C1B497'
}
export const CUSTOMIZATION_REFERRAL_WORD = [6171, 4753, 11537]
export const HIDE_REFERRAL_COMPANY_IDS = [4753, 11537]
export const HIDE_TRADING_AREA = [3738, 6117]
export const CUSTOM_JOB_FILTER_IDS = [6240, 6703]
export const SHOW_HR_JOB_FILTER_ID = 2239
export const SHOW_HR_JOB_FILTER_OPTIONS = {
  8190: SHOW_HR_JOB_FILTER_ID
}
export const OVERSEAS_COMPANY_ID = [6119]
export const HIDDEN_SALARY_COMPANY_IDS = [4753, 3738, 11537]
export const LOCAL_LANGUAGE_KEY = 'ajinga_onboarding_lang'
export const QINIU_UPLOAD_TOKEN_EXPIRE = 60 * 59

export const ONBOARDING_QUESTION_TYPE = {
  TEXT: {
    i18nKey: 'admin.company.onboarding.questionType.text',
    value: 'TEXT'
  },
  DATE: {
    i18nKey: 'admin.company.onboarding.questionType.date',
    value: 'DATE'
  },
  SINGLE: {
    i18nKey: 'admin.company.onboarding.questionType.single',
    value: 'SINGLE'
  },
  // unSupport now
  // MULTIPLE: {
  //   i18nKey: 'admin.company.onboarding.questionType.multiple',
  //   value: 'MULTIPLE'
  // },
  ATTACHMENT: {
    i18nKey: 'admin.company.onboarding.questionType.attachment',
    value: 'ATTACHMENT'
  },
  LINK: {
    i18nKey: 'admin.company.onboarding.questionType.link',
    value: 'LINK'
  },
  LANGUAGE: {
    i18nKey: 'admin.company.onboarding.questionType.language',
    value: 'LANGUAGE'
  },
  NATIONALITY: {
    i18nKey: 'admin.company.onboarding.questionType.nationality',
    value: 'NATIONALITY'
  },
  COUNTRY: {
    i18nKey: 'admin.company.onboarding.questionType.country',
    value: 'COUNTRY'
  },
  PROVINCE: {
    i18nKey: 'admin.company.onboarding.questionType.province',
    value: 'PROVINCE'
  },
  CITY: {
    i18nKey: 'admin.company.onboarding.questionType.city',
    value: 'CITY'
  },
  LOCATION: {
    // this is a virtual type, worked for scoped type
    i18nKey: 'admin.company.onboarding.questionType.location',
    value: 'LOCATION'
  }
}

export const ONBOARDING_QUESTION_SCOPED_TYPE = ['COUNTRY', 'PROVINCE', 'CITY']

export const MICRO_SITE_TYPE = {
  local: 'local',
  onboarding: 'onboarding',
  crm: 'crm',
  crmCampaign: 'crmCampaign',
  satisfaction_survey: 'satisfactionSurvey',
  post_applicant: 'postApplicant',
  job_application: 'jobApplication'
}

export const MICRO_SITE_DEVICE_TYPE = {
  mobile: 'mobile',
  pc: 'pc'
}

export const NO_MESSAGE_ERROR_CODE = [
  20003003,
  20002005
]
export const NEED_MANUALLY_CLOSE_ERROR_CODE = [
  20002003
]

export const ACCOUNT_NEED_CREATE_PASSWORD_ERROR_CODE = 20006028

export const JD_CUSTOMIZED_IMAGE_ROOT_COMPANY_IDS = [3860, 4335, 4474, 5394, 5771, 6117]
export const HENKEL_PROTOCOL = {
  title: 'Declaration of Consent – Application Status',
  textP1: 'As a multinational company, Henkel will transfer your personal information to its headquarter and other overseas affiliates for human resources administrative purposes. Ajinga is a recruitment website located in the territory of the People’s Republic of China. Your personal information will be transferred by Henkel to Ajinga.',
  textP2: 'In order to deliver a first-class service to you, Henkel will transfer your application status information to Ajinga (<a href="https://www.ajinga.com/" target="_blank">https://www.ajinga.com/</a>). Your application status information will be used solely for the recruitment purposes, updating you of your application status, without your consent, Ajinga will not use your information for any other purposes. ',
  textP3: 'By checking the opt-in option, you hereby understand and consent that Henkel will transfer your personal information to our overseas affiliates for the aforementioned purposes; if you choose to refuse, we will not transfer your personal information to overseas.',
  textP4: 'You may withdraw your consent by pressing the revoke button on your candidate dashboard <a :href=\'$DjangoBaseUrl("/referral/personal-info/")\' target="_blank">page</a>. If you withdraw your consent, Henkel will stop transferring your personal information to our overseas affiliates and delete your personal information in any overseas servers.'
}

export const DEFAULT_COMPANY_LOGO_PATH = '/static/images_en/default_company.jpg'

export const CHINA_COUNTRY_CODE = '+86'

export const ACCOUNT_TYPE = {
  HR: 'recruiter',
  CANDIDATE: 'candidate',
  HIRING_MANAGER: 'hiring-manager',
  EMPLOYEE: 'employee',
  ALUMNI: 'alumni',
  AGENCY: 'agency'
}

export const HM_PC_DASHBOARD_PATH = '/recruiter-pc/v-admin/hm/dashboard'

export const HM_MOBILE_DASHBOARD_PATH = '/recruiter-app/v-admin/hm/dashboard'

export const HM_DASHBOARD_PATH = HM_PC_DASHBOARD_PATH

export const HM_PC_INTERVIEW_PATH = '/recruiter-pc/v-admin/hm/interview'

export const HM_MOBILE_INTERVIEW_PATH = '/recruiter-app/v-admin/hm/dashboard/interview'

export const LOGIN_TYPE = {
  REGISTER_LOGIN: 'register',
  PASSWORD_LOGIN: 'login'
}

export const FACEBOOK_APP_ID = '552382705178246'

export const HR_REPORT_CONFIG_DATA_TYPE = {
  CHART: 'CHART',
  DASHBOARD: 'DASHBOARD'
}

export const DATE_PICKER_SHORTCUTS = {
  today: {
    unit: 'day',
    start: moment.duration(0, 'days'),
    end: moment.duration(1, 'days')
  },
  yesterday: {
    unit: 'day',
    start: moment.duration(-1, 'days'),
    end: moment.duration(0, 'days')
  },
  lastWeek: {
    unit: 'day',
    start: moment.duration(-1, 'weeks'),
    end: moment.duration(0, 'days')
  },
  lastMonth: {
    unit: 'day',
    start: moment.duration(-1, 'months'),
    end: moment.duration(0, 'days')
  },
  last3Month: {
    unit: 'day',
    start: moment.duration(-3, 'months'),
    end: moment.duration(0, 'days')
  },
  last6Month: {
    unit: 'day',
    start: moment.duration(-6, 'months'),
    end: moment.duration(0, 'days')
  },
  thisYear: {
    unit: 'day',
    start: moment.duration(-moment().dayOfYear() + 1, 'days'),
    end: moment.duration(0, 'days')
  },
  lastYear: {
    unit: 'day',
    start: moment.duration(-1, 'years'),
    end: moment.duration(0, 'days')
  }
}

export const INTEGRATION_TYPE = {
  SYNC_JOB_FROM: 'SYNC_JOB_FROM_',
  PULL_APPLICANT_FROM: 'PULL_APPLICANT_FROM_',
  SYNC_EMPLOYEE_FROM: 'SYNC_EMPLOYEE_FROM_',
  SYNC_APPLICANT_STATUS_FROM: 'SYNC_APPLICANT_STATUS_FROM_',
  SYNC_APPLICANT_TO: 'SYNC_APPLICANT_TO_',
  SYNC_APPLICANT_STATUS_TO: 'SYNC_APPLICANT_STATUS_TO_'
}
